import BaseApiClient from '@api-client/BaseApiClient';
import { CompanyDropdowns } from '@interfaces/Company.interface';

export class ApiBrokerData extends BaseApiClient {
  async getCompanyDropdowns(): Promise<CompanyDropdowns[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/data-lists?filter[group]=company')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { brokerDataQueryKeys } from './query-keys';
export { useBrokerDataCompanyDropdownsQuery } from './use-broker-data-queries';

